import api from './';

export default {
  getRegularTasks() {
    return api.post('RegularTasks/GetList', {}).then(response => response.data);
  },

  getRegularTask(arg) {
    return api.post('RegularTasks/Get', { regularTaskGuid: arg }).then(response => response.data);
  },

  getListByProject(arg) {
    return api
      .post('RegularTasks/GetListByProject', { taskGuid: arg })
      .then(response => response.data);
  },
  getListByRequirement(arg) {
    return api
      .post('RegularTasks/GetListByRequirement', { ProjectTaskGuid: arg })
      .then(response => response.data);
  },
  saveRegularTask(arg) {
    let args = {
      regularTaskGuid : arg.regularTask.regularTaskGuid ,
      typeGuid : arg.regularTask.typeGuid,
      name :arg.regularTask.name,
      estimatedHours : arg.regularTask.estimatedHours,
      timeMax :arg.regularTask.timeMax,
      timeMin : arg.regularTask.timeMin,
      multiplicator : arg.regularTask.multiplicator,
      relatedProjectRegularTaskGuid : arg.regularTask.regularTaskGuid,
      projectRegularTaskId  : arg.regularTask.projectRegularTaskId,
      isActive : true
    }
    return api.post('RegularTasks/Save',  {regularTask: args} ).then(response => response.data);
  },

  searchRegularTask(arg) {
    return api.post('RegularTasks/Search', { search: arg }).then(response => response.data);
  },

  deleteRegularTask(arg) {
    return api
      .post('RegularTasks/Delete', { regularTaskGuid: arg })
      .then(response => response.data);
  },
};
